import React from "react";
import { StepWiseSolution } from "../../types/ContentData";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { WithStyles, createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import cx from "classnames";
import _ from 'lodash';
import AddFeedbackPopup from "../ContentCreate/AddFeedbackPopup";


const styles = (theme: Theme) =>
  createStyles({
    // Solution Tabs
    tabPanel: {
      marginTop: 20,
      marginBottom: 12,
      display: 'inline-flex',
      position: 'relative',
      width: 'auto',
    },
    tabs: {
      fontSize: 16,
      lineHeight: "19px",
      color: "#333",
      marginRight: "30px!important",
      cursor: "pointer",
    },
    fontSM: {
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: "22px",
      color: "#333333",
    },
    titleDesc: {
      marginTop: theme.spacing.unit * 2,
      "& p": {
        margin: 0,
      },
      "& p > img, img": {
        maxWidth: "100%",
      },
    },
    activeTab: {
      fontWeight: 600,
      color: "#1d7dea!important",
      position: "relative",
      "&::before": {
        content: '""',
        width: "75px",
        height: "5px",
        borderRadius: 10,
        backgroundColor: "#1d7dea",
        position: "absolute",
        top: "26px",
      },
    },
    tabContent: {
      // marginTop:14,
    },
    stepSubHeading: {
      fontSize: 14,
      lineHeight: "17px",
      fontWeight: 600,
      color: "#333",
      marginTop: "18px!important",
    },
    stepsContent: {
      fontSize: 14,
      lineHeight: "24px",
      color: "#666",
      marginTop: "5px!important",
    },
    formulaSection: {
      background: "#F9F9F9",
      border: "1px solid #E2E2E2",
      padding: "10px 15px",
    },
    HeadingTxt: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: "22px",
      color: "#666",
    },
    blueColor: {
      color: "#1D7DEA",
    },
    feedbackContainer: {
      position: 'relative',
      '& .feedbackBlock': {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2
      }
    },
    feedbackHighlight:{
      cursor: 'pointer',
      '&:hover':{
        color: '#1d7dea',
      }
    }
  });

interface Props extends WithStyles<typeof styles> {
  data: StepWiseSolution[];
  updateTagName?: Function;
  questionIndex?: number;
  showColor: boolean;
  openFeedback: boolean;
  showValidationFeedback?: boolean;
  feedbackData?: any;
  onSectionClick?: Function;
  allowFeedbacks?: boolean;
  handleAddFeedback?: Function;
  handleCloseFeedback?: Function;
}
interface State {
  activeTab: number;
}

class StepWiseSolutionPreview extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
    this.renderSingleSolutionTitle = this.renderSingleSolutionTitle.bind(this)
    this.updateTag = this.updateTag.bind(this)
  }

  setActiveTab = (tab: number) => {
    this.setState({
      activeTab: tab,
    });
  };
  updateTag() {
    if(this.props.updateTagName && this.props.questionIndex !== undefined) {
      this.props.updateTagName("update", this.props.questionIndex)
    } else {
      if(this.props.updateTagName)
      this.props.updateTagName("update")
    }
  }
  renderSingleSolutionTitle = () => {
    const { classes, showValidationFeedback = false, feedbackData, allowFeedbacks, handleAddFeedback, handleCloseFeedback } = this.props;
    return (
      <div className={classes.titleDesc}>
        <Typography variant="body2" className={classes.fontSM} onClick={() => this.updateTag()}>
         <span 
         id={this.props.showColor ? 'feedbackScroll' : ''}
         className={`${classes.feedbackContainer} ${this.props.showColor  ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}` }>
          Solutions:
          { showValidationFeedback && <AddFeedbackPopup handleAdd={handleAddFeedback} handleCancel={handleCloseFeedback} allowFeedbacks={allowFeedbacks} feedbackData={feedbackData} /> }
          </span>
        </Typography>
      </div>
    );
  };

  renderMultiSolutionTabs = () => {
    const { data, classes, showValidationFeedback = false, feedbackData, allowFeedbacks, handleAddFeedback, handleCloseFeedback } = this.props;
    const { activeTab } = this.state;
    return (
      <Grid container justify="flex-start" className={classes.tabPanel}>
        {data.map((solution, index) => {
          const solutionNo = index + 1;
          const isActive = activeTab === index;
          return (
            <Grid item key={solutionNo}>
              <Typography
                className={cx(classes.tabs, isActive && classes.activeTab)}
                onClick={() => this.setActiveTab(index)}
              >
                Solution{solutionNo}
              </Typography>
            </Grid>
          );
        })}
        { showValidationFeedback && <AddFeedbackPopup handleAdd={handleAddFeedback} handleCancel={handleCloseFeedback} allowFeedbacks={allowFeedbacks} feedbackData={feedbackData} /> }
      </Grid>
    );
  };

  handleSectionClick = () => {
    const { onSectionClick } = this.props;
    onSectionClick && onSectionClick();
  }

  render() {
    const { data, classes } = this.props;
    const { activeTab } = this.state;
    if (!data || !data.length) {
      return null;
    }

    const { solutionSteps, formulaUsed } = data[activeTab];

    const isEmpty = data.length === 1 && solutionSteps.length === 0;

    if (isEmpty) {
      return this.renderSingleSolutionTitle();
    }
    const isSingleSolution = data.length === 1;
    return (
      <div onClick={this.handleSectionClick}>
        {isSingleSolution
          ? this.renderSingleSolutionTitle()
          : this.renderMultiSolutionTabs()}

        <Grid
          container
          justify="flex-start"
          direction="column"
          className={classes.tabContent}
        >
          {solutionSteps.map(({ solution, stepNo }) => {
            return (
              <Grid item key={stepNo}>
                <Typography className={classes.stepSubHeading}>
                  Step - {stepNo}
                </Typography>
                <Typography
                  className={classes.stepsContent}
                  dangerouslySetInnerHTML={{ __html: solution }}
                />
              </Grid>
            );
          })}
          {formulaUsed && (
            <Grid item className={classes.formulaSection}>
              <Typography className={classes.HeadingTxt}>
                Formula Used
              </Typography>
              <Typography
                className={classes.stepsContent}
                dangerouslySetInnerHTML={{ __html: formulaUsed }}
              />
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(StepWiseSolutionPreview);
